import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";

export const businessWinnerApi = createApi({
  reducerPath: "businessWinnerApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
  }),
  endpoints: (build) => ({
    getBusinessWinners: build.query({
      query(params) {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/business-winners/?${queryParams}`,
          method: "GET",
        };
      },
      providesTags: ["BusinessWinners"],
    }),
    getBusinessWinnerById: build.query({
      query(id) {
        return {
          url: `/admin/business-winners/${id}`,
          method: "GET",
        };
      },
      providesTags: ["BusinessWinner"],
    }),
    getBusinessWinnersByGame: build.query({
      query(gameId) {
        return {
          url: `/admin/business-winners/game/${gameId}`,
          method: "GET",
        };
      },
      providesTags: ["BusinessWinners"],
    }),
    getBusinessWinnersByBusiness: build.query({
      query(nui) {
        return {
          url: `/admin/business-winners/business/${nui}`,
          method: "GET",
        };
      },
      providesTags: ["BusinessWinners"],
    }),
    createBusinessWinner: build.mutation({
      query: (data) => ({
        url: "/admin/business-winners/",
        method: "POST",
        data,
      }),
      invalidatesTags: ["BusinessWinners"],
    }),
    getBusinessStats: build.query({
      query(params = {}) {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/business-stats/${queryParams ? `?${queryParams}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["BusinessStats"],
    }),
  }),
});

export const {
  useGetBusinessWinnersQuery,
  useLazyGetBusinessWinnersQuery,
  useGetBusinessWinnerByIdQuery,
  useGetBusinessWinnersByGameQuery,
  useLazyGetBusinessWinnersByGameQuery,
  useGetBusinessWinnersByBusinessQuery,
  useLazyGetBusinessWinnersByBusinessQuery,
  useCreateBusinessWinnerMutation,
  useGetBusinessStatsQuery,
  useLazyGetBusinessStatsQuery,
} = businessWinnerApi;
